<template>
  <div class="app-wrapper">
    <div class="app" v-if="this.$store.state.postLoaded">
      <Navigation v-if="!this.$store.state.navigationDisabled" />
      <router-view />
      <Footer v-if="!this.$store.state.navigationDisabled" />
    </div>
  </div>
</template>

<script>
import Navigation from "./components/Navigation.vue";
import Footer from "./components/Footer.vue";
import firebase from "firebase/app";
import "firebase/auth";
export default {
  name: "app",
  components: {
    Navigation,
    Footer,
  },
  data() {
    return {};
  },
  created() {
    firebase.auth().onAuthStateChanged((user) => {
      this.$store.commit("updateUser", user);
      if (user) {
        this.$store.dispatch("getCurrentUser", user);
      }
    });
    this.checkRoute();
    this.$store.dispatch("getPost");
  },
  mounted() { },
  methods: {
    checkRoute() {
      if (
        this.$route.name === "Login" ||
        this.$route.name === "Register" ||
        this.$route.name === "ForgotPassword"
      ) {
        this.$store.state.navigationDisabled = true;
        this.$store.state.isHomePage = false;
        return;
      }
      if (this.$route.name === "Home" || this.$route.name === "Prints" || this.$route.name === "ComingSoon") {
        this.$store.state.navigationDisabled = false;
        this.$store.state.isHomePage = true;
        return;
      }
      this.$store.state.navigationDisabled = false;
      this.$store.state.isHomePage = false;
    },
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style lang="scss">
@import url("https://fonts.googleapis.com/css2?family=Quicksand:wght@300;400;500;600;700&display=swap");

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Quicksand", sans-serif;
}

.app {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}

.container {
  max-width: 1440px;
  margin: 0 auto;
}

.link {
  cursor: pointer;
  text-decoration: none;
  text-transform: uppercase;
  color: black;
}

.link-light {
  color: #fff;
}

.arrow {
  margin-left: 8px;
  width: 12px;

  path {
    fill: #000;
  }
}

.arrow-light {
  path {
    fill: #fff;
  }
}

button,
.router-button {
  transition: 500ms ease all;
  cursor: pointer;
  margin-top: 24px;
  padding: 12px 24px;
  background-color: #303030;
  color: #fff;
  border-radius: 20px;
  border: none;
  text-transform: uppercase;

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: rgba(48, 48, 48, 0.7);
  }
}

.button-ghost {
  color: #000;
  padding: 0;
  border-radius: 0;
  margin-top: 50px;
  font-size: 15px;
  font-weight: 500;
  background-color: transparent;

  @media (min-width: 700px) {
    margin-top: 0;
    margin-left: auto;
  }

  i {
    margin-left: 8px;
  }
}

.button-light {
  background-color: transparent;
  border: 2px solid #fff;
  color: #fff;
}

.button-inactive {
  pointer-events: none !important;
  cursor: none !important;
  background-color: rgba(128, 128, 128, 0.5) !important;
}

.error {
  text-align: center;
  font-size: 12px;
  color: red;
}

.blog-card-wrap {
  position: block;
  padding: 80px 16px;
  background-color: #f1f1f1;
  

  @media (min-width: 500px) {
    padding: 70px 16px 100px 16px;
  }

  .blog-cards {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    

    @media (min-width: 700px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 900px) {
      grid-template-columns: repeat(2, 1fr);
      padding: 0px 80px;
    }

    @media (min-width: 1500px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }

  .all-blog-cards {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;
    align-items: center;
    justify-items: center;
    padding: 0px 50px;

    @media (min-width: 800px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1100px) {
      padding: 0px 150px;
    }
  }
}

.collection-wrap {
  display: flex;
  position: center;
  padding: 80px 16px;
  background-color: #f1f1f1;
  justify-content: center;
  align-items: center;

  @media (min-width: 500px) {
    padding: 70px 16px;
  }

  .collections {
    display: grid;
    gap: 60px;
    grid-template-columns: 1fr;

    @media (min-width: 700px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1020px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1400px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

.print-wrap {
  display: flex;
  position: center;
  padding: 80px 16px;
  background-color: #f1f1f1;
  justify-content: center;
  align-items: center;

  @media (min-width: 500px) {
    padding: 70px 16px;
  }

  .prints {
    display: grid;
    gap: 32px;
    grid-template-columns: 1fr;

    @media (min-width: 680px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (min-width: 1000px) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (min-width: 1320px) {
      grid-template-columns: repeat(4, 1fr);
    }
  }
}

.swiper-wrap {
  display: flex;
  position: center;
  padding: 10px 0px;
  background-color: #f1f1f1;
  justify-content: center;
  align-items: center;

  @media (min-width: 500px) {
    padding: 20px 16px;
  }
}

.slider-title {
  display: flex;
  position: center;
  padding: 70px 0px 30px 0;
  background-color: #f1f1f1;
  justify-content: center;
  align-items: center;
}
</style>
